import Button from '../../general/button/button';

import styles from './confirm-modal.module.scss';

type Props = {
  message: string;
  onPrimaryClick: () => void;
  onSecondaryClick?: () => void;
  primaryLabel: string;
  secondaryLabel?: string;
};

export const ConfirmModal = ({
  message,
  onPrimaryClick,
  onSecondaryClick,
  primaryLabel,
  secondaryLabel,
}: Props) => {
  const hasSecondaryButton = onSecondaryClick && secondaryLabel;
  return (
    <section className={styles['confirm-modal']}>
      <h1 className={styles['confirm-modal__title']}>{message}</h1>
      <ul className={styles['confirm-modal__buttons']}>
        <li className={styles['confirm-modal__button']}>
          {primaryLabel && (
            <Button
              dataHook='confirm-modal-primary'
              text={primaryLabel}
              onClick={onPrimaryClick}
            />
          )}
        </li>
        {hasSecondaryButton && (
          <li className={styles['confirm-modal__button']}>
            <Button
              theme='outlined--on-surface'
              dataHook='confirm-modal-secondary'
              text={secondaryLabel}
              onClick={onSecondaryClick}
            />
          </li>
        )}
      </ul>
    </section>
  );
};

ConfirmModal.displayName = 'ConfirmModal';
export default ConfirmModal;
